(() => {
  const SELECTOR = '[data-minaco-cookie-consent]';
  const LOCAL_CHOICE_KEY = 'minaco_cookie_consent_choice';

  function init(root) {
    if (!root || root.dataset.mccReady === 'true') return;
    root.dataset.mccReady = 'true';

    const panel = root.querySelector('.minaco-cookie-consent__panel');
    const main = root.querySelector('[data-mcc-main]');
    const preferencesView = root.querySelector('[data-mcc-preferences]');
    const acceptButtons = root.querySelectorAll('[data-mcc-accept]');
    const rejectButtons = root.querySelectorAll('[data-mcc-reject]');
    const preferencesButton = root.querySelector('[data-mcc-open-preferences]');
    const backButton = root.querySelector('[data-mcc-back]');
    const saveButton = root.querySelector('[data-mcc-save]');
    const enabled = root.dataset.enabled === 'true';
    const displayMode = root.dataset.displayMode || 'always_until_choice';
    let opener = null;

    function api() {
      return window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
    }

    function open({ force = false } = {}) {
      if (!force && !enabled) return;
      opener = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => panel?.focus({ preventScroll: true }));
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      if (opener && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
    }

    function markChoice() {
      try { localStorage.setItem(LOCAL_CHOICE_KEY, '1'); } catch (_) {}
    }

    function hasLocalChoice() {
      try { return localStorage.getItem(LOCAL_CHOICE_KEY) === '1'; } catch (_) { return false; }
    }

    function currentConsent() {
      const privacy = api();
      if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return null;
      try { return privacy.currentVisitorConsent(); } catch (_) { return null; }
    }

    function hasApiChoice(consent) {
      if (!consent) return false;
      return ['analytics', 'marketing', 'preferences'].some((key) => consent[key] === 'yes' || consent[key] === 'no');
    }

    function setConsent(values) {
      const privacy = api();
      if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
        markChoice();
        close();
        return;
      }
      privacy.setTrackingConsent(values, () => {
        markChoice();
        close();
        document.dispatchEvent(new CustomEvent('minaco:cookie-consent-complete', { detail: values }));
      });
    }

    function showMain() {
      if (main) main.hidden = false;
      if (preferencesView) preferencesView.hidden = true;
    }

    function showPreferences() {
      const consent = currentConsent();
      root.querySelectorAll('[data-mcc-choice]').forEach((input) => {
        const value = consent?.[input.dataset.mccChoice];
        input.checked = value === 'yes';
      });
      if (main) main.hidden = true;
      if (preferencesView) preferencesView.hidden = false;
      preferencesView?.querySelector('button, input')?.focus({ preventScroll: true });
    }

    acceptButtons.forEach((button) => button.addEventListener('click', () => setConsent({ analytics: true, marketing: true, preferences: true })));
    rejectButtons.forEach((button) => button.addEventListener('click', () => setConsent({ analytics: false, marketing: false, preferences: false })));
    preferencesButton?.addEventListener('click', showPreferences);
    backButton?.addEventListener('click', showMain);
    saveButton?.addEventListener('click', () => {
      const values = {};
      root.querySelectorAll('[data-mcc-choice]').forEach((input) => { values[input.dataset.mccChoice] = input.checked; });
      setConsent(values);
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !root.classList.contains('is-open')) return;
      const focusables = [...root.querySelectorAll('button:not([disabled]):not([hidden]), input:not([disabled]):not([hidden]), a[href]:not([hidden]), [tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    function decideInitialVisibility(attempt = 0) {
      if (window.Shopify?.designMode || !enabled) return;
      const privacy = api();
      if (!privacy && attempt < 20) {
        window.setTimeout(() => decideInitialVisibility(attempt + 1), 150);
        return;
      }

      if (displayMode === 'shopify_required') {
        let shouldShow = false;
        try { shouldShow = !!privacy?.shouldShowBanner?.(); } catch (_) {}
        if (shouldShow) open();
        return;
      }

      const consent = currentConsent();
      if (!hasLocalChoice() && !hasApiChoice(consent)) open();
    }

    decideInitialVisibility();

    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId === root.dataset.sectionId) open({ force: true });
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.detail.sectionId === root.dataset.sectionId) { showMain(); close(); }
    });
  }

  function boot(scope = document) { scope.querySelectorAll(SELECTOR).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
